<template>
    <div class="phoneBox">
        <div class="phoneInfo">
            <img src="@/assets/order/phone.png" alt="" class="phone"> 
            <div>{{phone}}</div>
        </div>
        <div class="callBtn" @click.stop="handleCopy">Copy</div>
    </div>
</template>
<script>
export default {
    name:'OrderPhone',
    props:{
        phone:{
            type:String,
            default:''
        }
    },
    methods:{
        handleCopy(){
            const phone = (this.phone || '').trim()
            if(!phone) return

            // Prefer Clipboard API; fall back to execCommand for older browsers / non-secure contexts.
            const doToast = (msg) => {
                if (this.$toast) return this.$toast(msg)
                // Avoid hard dependency on Vant Toast import in this shared component.
                // eslint-disable-next-line no-console
            }

            if (typeof navigator !== 'undefined' && navigator.clipboard && navigator.clipboard.writeText) {
                navigator.clipboard.writeText(phone).then(() => {
                    doToast('Phone number copied')
                }).catch(() => {
                    this._fallbackCopy(phone, doToast)
                })
                return
            }

            this._fallbackCopy(phone, doToast)
        },
        _fallbackCopy(text, doToast){
            try {
                const textArea = document.createElement('textarea')
                textArea.value = text
                textArea.setAttribute('readonly', '')
                textArea.style.position = 'fixed'
                textArea.style.left = '-9999px'
                document.body.appendChild(textArea)
                textArea.select()
                document.execCommand('copy')
                document.body.removeChild(textArea)
                doToast('Phone number copied')
            } catch (e) {
                doToast('Copy failed')
            }
        }
    }
}
</script>

<style lang="scss" scoped>
    .phoneBox{
        display: flex;
        align-items: center;
        justify-content: space-between;
        .callBtn{
            width: 2.5625rem;
            height: 1.5rem;
            border: 1px solid #1E3C3E;
            border-radius: .25rem;
            display: flex;
            justify-content: center;
            align-items: center;
            color: #1E3C3E;
        }
        .phoneInfo{
            display: flex;
            align-items: center;
            .phone{
                width: 1.5rem;
                height: 1.5rem;
                display: block;
            }
        }
        
    }
</style>
